export const saveJson = (key, json) => {
	localStorage.setItem(key, JSON.stringify(json));
}

export const getJson = key => {
	const item = localStorage.getItem(key)
	try {
		return item ? JSON.parse(item) : null
	} catch(e) {
		return null;
	}
}